(ns frontend.ui.component.dynamic-table.heading-row.style
  (:require
   [frontend.ui.style.theme.core :as theme]))

(defn heading
  []
  ^{:pseudo {}}
  {:position :relative})

(defn title-cell
  []
  {:padding             "0 0.5rem 1rem"
   :font-size           :12px
   :font-weight         :bold
   :text-align          :left
   :position            :sticky
   :left                0
   :background-color    :inherit
   :border-bottom       "1px solid"
   :border-bottom-color (theme/color [:dynamic-table :th :border])
   :vertical-align      :bottom
   :text-transform      :uppercase})

(defn th-cell
  []
  {:text-transform      :uppercase
   :font-size           :12px
   :text-align          :right
   :font-weight         :bold
   :padding             "0 0.5rem 1rem"
   :border-bottom       "1px solid"
   :border-bottom-color (theme/color [:dynamic-table :th :border])
   :vertical-align      :bottom
   :background-color    :inherit})

(defn col
  []
  {:text-transform   :uppercase
   :font-size        :12px
   :text-align       :right
   :padding          "0 0.5rem 1rem"
   :vertical-align   :bottom
   :background-color :inherit})

(defn number-col
  []
  ^{:extend col}
  {:text-align "right"})
